import { createContext } from 'react';

const AppContext = createContext(undefined);
const StepContext = createContext(undefined);
const WorkflowContext = createContext(undefined);

export { StepContext, WorkflowContext, AppContext };
